module.exports = __webpack_public_path__ + "static/media/darren.dfd6ef13.png";